<mat-nav-list>
  <a mat-list-item (click)="send()">
    <span mat-line>Enviar notificación</span>
  </a>
</mat-nav-list>
